import FormReports from '@/modules/formReports/FormReports'
import { closePublishSheet } from '@/redux/slices/publishSheetSlice'
import { useAppDispatch } from '@/redux/store'
import { useLocalSearchParams } from 'expo-router'
import { useEffect } from 'react'
import { Platform, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import FormStackScreen from './FormStackScreen'

export default function FormReportsPage() {
  const insets = useSafeAreaInsets()
  const { formToken } = useLocalSearchParams<{ formToken: string }>()
  const dispatch = useAppDispatch()

  useEffect(() => {
    return () => {
      dispatch(closePublishSheet())
    }
  }, [dispatch])

  return (
    <View className="flex-1" style={Platform.OS === 'android' ? { paddingBottom: insets.bottom } : undefined}>
      <FormStackScreen
        formToken={formToken}
        titlePrefix="报表"
        defaultBackHref={`/forms/${formToken}`}
        headerTransparent={false}
      />
      <FormReports formToken={formToken} />
    </View>
  )
}
